import { IS_ACTIVE } from "../_defs";
import { onHideCover } from "../functions/_hideCover";

const CHAR = document.createElement("span");

CHAR.className = "c-kv__label-char";
CHAR.innerHTML = "<span></span>";

const show = (spans: HTMLElement[], next: () => void): void => {
  const interval = 100;

  spans.forEach((span, i) => {
    setTimeout(() => span.classList.add(IS_ACTIVE), i * interval);
  });
  setTimeout(next, interval * (spans.length / 2));
};

export const setupKv = (): void => {
  document.querySelectorAll<HTMLElement>("[data-kv]").forEach((kv) => {
    const spans: HTMLElement[] = [];

    kv.querySelectorAll<HTMLElement>("[data-kv-label]").forEach((label) => {
      const parent = label.parentNode;

      if (!parent) return;

      const frag = document.createDocumentFragment();

      label.childNodes.forEach((child) => {
        if (child.nodeType === 1) {
          frag.appendChild(child.cloneNode(false));
        } else if (child.nodeType === 3) {
          child.nodeValue?.split("").forEach((c) => {
            const span = CHAR.cloneNode(true) as HTMLElement;

            span.firstChild?.appendChild(document.createTextNode(c));
            frag.append(span);
            spans.push(span);
          });
        }
      });

      // eslint-disable-next-line no-param-reassign
      label.textContent = "";
      label.appendChild(frag);
    });

    const showBody = gsap.timeline().pause();
    const showOther = gsap.timeline().pause();

    kv.querySelectorAll<HTMLElement>("[data-kv-body]").forEach((body) => {
      showBody.add(
        gsap.fromTo(
          body,
          {
            y: "100%"
          },
          {
            y: 0,
            duration: 0.8,
            ease: Cubic.easeOut
          }
        )
      );

      body.querySelectorAll(":scope > *").forEach((x, i) => {
        showOther.add(
          gsap.fromTo(
            x,
            {
              opacity: 0,
              y: 20
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.8
            }
          ),
          i * 0.1 + 0.5
        );
      });
    });

    onHideCover(() =>
      show(spans, () => {
        showBody.resume();
        showOther.resume();
      })
    );
  });
};
